<template>
  <b-overlay :show="isLoading">
    <b-card no-body>
      <b-tabs card>
        <b-tab :title="$t('ordemResultado.modal.details.exames')" active>
          <b-table :items="exams" :fields="fields" hover>
            <template v-slot:cell(mapping_error)="{item: {mapping_error}}">
              <div class="d-flex w-100">
                <i v-if="mapping_error" class="fas fa-exclamation-triangle text-danger m-auto"/>
              </div>
            </template>
            <template v-slot:cell(exam_code)="linha">
              <b-button v-if="linha.item.value_quantity_value"
                        variant="link p-0 font-weight-bold"
                        @click="linha.toggleDetails()">{{ linha.item.exam_code }}
              </b-button>
              <span v-else>{{ linha.item.exam_code }}</span>
            </template>
            <template v-slot:cell(protocol_status)="{item}">
              <span v-if="item.protocol_status">
                {{ $t('ordemResultado.modal.details.protocolo_status.' + item.protocol_status) }}
              </span>
            </template>
            <template v-slot:cell(support)="{item}">
              <span v-if="item.support && item.support.sup_request_number">{{ item.support.sup_request_number }}</span>
            </template>
            <template v-slot:row-details="{item}">
              <b-table :fields="detailsfields" :items="[item]" borderless stacked>
                <template v-slot:cell(processed_at)="{item}">
                  {{ item.processed_at | formatDate }}
                </template>
                <template v-slot:cell(edit_reason)="{item}">
                  {{ item.edit_reason }}
                </template>
                <template v-slot:cell(edited_by_user_name)="{item}">
                  <span v-if="item.edit_reason">{{ item.edited_by_user_name }}</span>
                </template>
                <template v-slot:cell(value_quantity_type)="{item}">
                  {{ formatTipoResultado(item.value_quantity_type) }}
                </template>
              </b-table>
            </template>
          </b-table>
        </b-tab>
        <b-tab>
          <template #title>
            <i v-if="exams.some(item => item.mapping_error_complement === true)" class="fas fa-exclamation-triangle text-danger m-auto"/>
            {{ $t('ordemResultado.modal.details.complementos_exames') }}
          </template>
          <b-table :items="exams" :fields="fieldsComplement" hover>
            <template v-slot:cell(mapping_error_complement)="{item: {mapping_error_complement}}">
              <div class="d-flex w-100">
                <i v-if="mapping_error_complement" class="fas fa-exclamation-triangle text-danger m-auto"/>
              </div>
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.controle_qualidade')" v-if="this.transaction.quality_control_protocol !== null && this.transaction.type === 'Report'">
          <b-table :items="qualityControl" :fields="fieldsQualityControl" hover>
          </b-table>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.editar_recipiente')" v-if="this.transaction.type === 'Report' && this.transaction.integration_type === 'Automation' && this.transaction.new_report_original_recipient === null">
          <b-card
            :header="$t('ordemResultado.modal.details.editar_recipiente')"
            header-tag="header"
            :title="$t('ordemResultado.modal.details.resend.change_recipient')"
          >
            <b-card-text>
              {{ $t('ordemResultado.modal.details.resend.fix_recipient_number') }}
              <b-form-input v-model="recipientCode" :placeholder="$t('ordemResultado.modal.details.resend.fix_recipient_number_placeholder')">
              </b-form-input>
            </b-card-text>
            <b-card-text>
              {{ $t('ordemResultado.modal.details.resend.edit_reason') }}
              <b-form-textarea
                id="textarea"
                v-model="recipientReason"
                :placeholder="$t('ordemResultado.modal.details.resend.edit_reason_placeholder')"
                rows="4"
                max-rows="4">
              </b-form-textarea>
            </b-card-text>            
            <b-button @click="resendRecipient()" variant="primary" :show="sending">
              {{ $t('ordemResultado.modal.details.resend.resend_result') }}
            </b-button>
          </b-card>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.recipientes_reenviados')" v-if="this.transaction.type === 'Report' && this.transaction.recipients_changed.length > 0">
          <b-table :items="this.transaction.recipients_changed" :fields="fieldsRecipientResended" hover>
            <template v-slot:cell(created_at)="{item}">{{ item.created_at | formatDate }}</template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.recipiente_alterado')" v-if="this.transaction.type === 'Report' && this.transaction.integration_type === 'Automation' && this.transaction.new_report_original_recipient !== null">
          <b-card :header="$t('ordemResultado.modal.details.recipiente_alterado')" header-tag="header">
            <b-row no-gutters class="mb-2">
              <b-col md="2">
                <b-card-text>
                  {{ $t('ordemResultado.modal.details.changed.original_recipient') }}
                </b-card-text>
              </b-col>
              <b-col md="10">
                <b-card-text>
                  {{ this.transaction.new_report_original_recipient }}
                </b-card-text>
              </b-col>
            </b-row>
            <b-row no-gutters class="mb-2">
              <b-col md="2">
                <b-card-text>
                  {{ $t('ordemResultado.modal.details.changed.user_id') }}
                </b-card-text>
              </b-col>
              <b-col md="10">
                <b-card-text>
                  {{ this.transaction.new_report_vs_user_id }}
                </b-card-text>
              </b-col>
            </b-row>
            <b-row no-gutters class="mb-2">
              <b-col md="2">
                <b-card-text>
                  {{ $t('ordemResultado.modal.details.changed.user_name') }}
                </b-card-text>
              </b-col>
              <b-col md="10">
                <b-card-text>
                  {{ this.transaction.new_report_vs_user_name }}
                </b-card-text>
              </b-col>
            </b-row>
            <b-row no-gutters class="mb-2">
              <b-col md="2">
                <b-card-text>
                  {{ $t('ordemResultado.modal.details.changed.reason') }}
                </b-card-text>
              </b-col>
              <b-col md="10">
                <b-card-text>
                  {{ this.transaction.new_report_reason }}
                </b-card-text>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.pet')" v-if="this.transaction.tutor !== null && this.transaction.type === 'Order'">
          <b-table :items="pets" :fields="fieldsPet" hover>
          </b-table>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.erros_suporte')" v-if="this.transaction.exams && this.transaction.exams.length > 0 && this.transaction.exams[0].support_errors !== null && this.transaction.type === 'Order'">
          <b-table :items="supportErrors" :fields="fieldsSupportError" hover>
            <template v-slot:cell(error_created_at)="{ item: { error_created_at }}">
              {{ error_created_at | formatDate }}
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('ordemResultado.modal.details.erros_origem')" v-if="this.transaction.exams && this.transaction.exams.length > 0 && this.transaction.exams[0].support_errors !== null && this.transaction.type === 'Report'">
          <b-table :items="supportErrors" :fields="fieldsSupportError" hover>
            <template v-slot:cell(error_created_at)="{ item: { error_created_at }}">
              {{ error_created_at | formatDate }}
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>    
  </b-overlay>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import OrderRepository from "@/repositories/vns/OrderRepository";
import Cookies from "js-cookie";

export default {
  name: "ExamsDetail",
  props: {
    typeTransaction: {
      type: String
    },
    id: {
      type: String
    },
    transaction: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      recipient: 'recipient/current',
      isLoadingCurrent: 'recipient/isLoadingCurrent',
    }),
    isLoading() {
      return this.exams.length === 0 && (this.isLoadingCurrent.orderExams || this.isLoadingCurrent.reportExams)
    },
    exams() {
      if (this.recipient instanceof Array) {
        let exams = []
        this.recipient.map(recipient => {
          if (this.typeTransaction === 'Order' && recipient.orders) {
            if (
                recipient.orders.find(o => o.id === this.id) &&
                recipient.orders.find(o => o.id === this.id).exams
            )
            exams = [...exams, ...recipient.orders.find(o => o.id === this.id).exams]            
          }

          if (this.typeTransaction === 'Report' && recipient.reports) {
            if (
                recipient.reports.find(r => r.id === this.id) &&
                recipient.reports.find(r => r.id === this.id).exams
            ){
              let exam = recipient.reports.find(r => r.id === this.id).exams
              exam[0].processed_at = recipient.reports.find(r => r.id === this.id).processed_at
              exams = [...exams, ...exam]
            }
          }
        })

        return exams
      }

      if (this.typeTransaction === 'Order' && this.recipient.orders) {        
        return this.recipient.orders.find(o => o.id === this.id).exams
      }

      if (this.typeTransaction === 'Report' && this.recipient.reports) {        
        let exam = this.recipient.reports.find(r => r.id === this.id).exams
        exam[0].processed_at = recipient.reports.find(r => r.id === this.id).processed_at
        return exam
      }

      return []
    },
    pets() {
      return [this.transaction]
    },
    supportErrors() {
      return this.transaction.exams[0].support_errors
    },
    qualityControl() {
      return [this.transaction]
    },
    fields() {
      const support = this.exams.find(e => e.support)
      return [
        this.exams.find(e => e.mapping_error) ? {key: 'mapping_error', label: 'Error'} : null,
        {key: 'exam_code', label: this.$t('ordemResultado.modal.details.exame_lis'), sortable: true},
        {key: 'exam_mapped_code', label: this.$t('ordemResultado.modal.details.exame') + ' ' + this.$t('ordemResultado.modal.details.destino'), sortable: true},
        {key: 'specimen_code', label: this.$t('ordemResultado.modal.details.material_lis')},
        {key: 'specimen_mapped_code', label: this.$t('ordemResultado.modal.details.material') + ' ' + this.$t('ordemResultado.modal.details.destino')},
        support ? {key: 'support', label: this.$t('ordemResultado.modal.details.numero_pedido')} : null,
        {key: 'protocol_status', label: this.$t('ordemResultado.modal.details.status_protocolo')}
      ]
    },
    fieldsComplement() {
      return [
        this.exams.find(e => e.mapping_error_complement) ? {key: 'mapping_error_complement', label: 'Error'} : null,
        {key: 'exam_code', label: this.$t('ordemResultado.modal.details.exame_lis'), sortable: true},
        {key: 'method_code', label: this.$t('ordemResultado.modal.details.metodo') + ' ' + this.$t('ordemResultado.modal.details.origem')},
        {key: 'method_mapped_code', label: this.$t('ordemResultado.modal.details.metodo') + ' ' + this.$t('ordemResultado.modal.details.destino')},
        {key: 'specimen_addition', label: this.$t('ordemResultado.modal.details.material_adicional')},
        {key: 'specimen_complement', label: this.$t('ordemResultado.modal.details.complemento_material_lis')},
        {key: 'specimen_complement_mapped', label: this.$t('ordemResultado.modal.details.complemento_material')}
      ]
    },
    fieldsRecipientResended() {
      return [
        {key: 'new_recipient', label: this.$t('ordemResultado.modal.details.novo_recipiente'), sortable: true},
        {key: 'vs_user_id', label: this.$t('ordemResultado.modal.details.vs_usuario_id')},        
        {key: 'vs_user_name', label: this.$t('ordemResultado.modal.details.vs_usuario_name')},
        {key: 'created_at', label: this.$t('ordemResultado.modal.details.criado_em'), sortable: true},
        {key: 'reason', label: this.$t('ordemResultado.modal.details.motivo')}
      ]
    },
    fieldsPet() {
      const support = this.exams.find(e => e.support)
      return [
        {key: 'integration_patient_specie', label: this.$t('ordemResultado.modal.details.especie')},
        {key: 'integration_patient_breed', label: this.$t('ordemResultado.modal.details.raca')},
        {key: 'integration_patient_coat', label: this.$t('ordemResultado.modal.details.pelagem')},
        {key: 'integration_patient_size', label: this.$t('ordemResultado.modal.details.porte')}
      ]
    },
    fieldsSupportError() {
      return [
        {key: 'message', label: this.$t('ordemResultado.modal.details.mensagem')},
        {key: 'error_created_at', label: this.$t('ordemResultado.modal.details.data_hora')},
      ]
    },
    fieldsQualityControl() {
      return [
        {key: 'quality_control_protocol', label: this.$t('ordemResultado.modal.details.protocolo')}
      ]
    }    
  },
  data(){
    return {
      recipientCode: null,
      recipientReason: null,
      sending: false,
      detailsfields: [
        {
          key: 'value_quantity_value',
          label: this.$t('ordemResultado.modal.details.valor')
        },
        {
          key: 'value_quantity_unit',
          label: this.$t('ordemResultado.modal.details.unidade')
        },
        {
          key: 'value_quantity_type',
          label: this.$t('ordemResultado.modal.details.tipo_resultado')
        },
        {
          key: 'reference_range_text',
          label: this.$t('ordemResultado.modal.details.texto_referencia')
        },
        {
          key: 'reference_range_structured',
          label: this.$t('ordemResultado.modal.details.estrutura_referencia')
        },
        {
          key: 'processed_at',
          subKey: 'date',
          label: this.$t('ordemResultado.modal.details.processado')
        },
        {
          key: 'edit_reason',
          label: this.$t('ordemResultado.modal.details.motivo_revisao')
        },
        {
          key: 'edited_by_user_name',
          label: this.$t('ordemResultado.modal.details.usuario_revisao')
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'recipient/listOrderExams',
      'recipient/listReportExams',
    ]),
    formatTipoResultado(value) {
      if (!value) return ''

      const labels = {
        decimal: this.$t('ordemResultado.modal.details.tipo_resultado_decimal'),
        alfanumerico: this.$t('ordemResultado.modal.details.tipo_resultado_alfanumerico')
      }

      return labels[value] || value
    },
    async resendRecipient() {
      if (this.transaction.recipient.trim() === this.recipientCode.trim()) {
        this.$snotify.error(this.$t('ordemResultado.messages.resend.recipient_diference'))
        return;
      }

      if (this.recipientReason === undefined || this.recipientReason === null) {
        this.$snotify.error(this.$t('ordemResultado.messages.resend.reason_required'))
        return;
      }

      this.sending = true
      try {

        let userId = Cookies.get('veus_usuario_id')
        let userName = Cookies.get('veus_nm_usuario')

        const resolve = async () => {
          this.$snotify.success(this.$t('ordemResultado.messages.resend.success'))
        }
        const reject = () => {
          this.$snotify.error(this.$t('ordemResultado.messages.resend.error'))
        }

        await OrderRepository.editRecipientReport({
          deviceName: this.transaction.vns,
          originalReportId: this.transaction.id,
          originalRecipient: this.transaction.recipient.trim(),
          recipientCode: this.recipientCode.trim(),
          recipientReason: this.recipientReason,
          userId: userId,
          userName: userName
        })
        .then(resolve)
        .catch(reject)
      } catch (e) {
        console.error(e)
      }

      this.sending = false
      this.$emit('search')
      this.$bvModal.hide('recipient-modal')
    }
  },
  async mounted() {
    this.recipientCode = this.transaction.recipient
    if (this.exams.length === 0) {
      if (this.typeTransaction === 'Order') {
        await this['recipient/listOrderExams'](this.id)
      }

      if (this.typeTransaction === 'Report') {
        
        await this['recipient/listReportExams'](this.id)
      }
    }
  }
}
</script>